import React from 'react';
import {
  createCrudMethodsListConfig,
  createFiltersPanelListConfig,
  createMethodApiCreateListConfig,
  createSortingMethodListConfig,
} from '@prometheus/utils';
import {
  createVault,
  getVaultFilters,
  getVaultSorting,
  getVaults,
} from '@/api';
import { ListConfigInterface } from '@prometheus/types';
import {
  CREATED_COLUMN,
  UPDATED_COLUMN,
  AUTHOR_COLUMN,
  NAME_COLUMN,
  ID_COLUMN,
} from '@prometheus/features';

export const vaultListConfig: ListConfigInterface<any, any> = {
  rowId: 'id',
  loadingMessage: 'Loading vaults...',
  addButtonTitle: 'Add Vault',
  moduleDescription: '',
  tableTitle: 'Vaults',
  listInitialSort: null,
  createCrudMethod: (typeContainer, parentId) => {
    return createCrudMethodsListConfig<any>(typeContainer, parentId, getVaults);
  },
  createFiltersPanel: (typeContainer, parentId) => {
    return createFiltersPanelListConfig(null, null, getVaultFilters);
  },
  createSortingMethod() {
    return createSortingMethodListConfig(null, {
      getSorting: getVaultSorting,
    });
  },
  cols: [
    ID_COLUMN({ id: 'id' }),
    NAME_COLUMN({ size: 300 }),
    {
      header: 'Database',
      accessorKey: 'dataSource.name',
      id: 'dataSource.name',
      size: 200,
    },
    {
      header: 'Vault Schema',
      accessorKey: 'vaultSchema',
      id: 'vaultSchema',
      size: 110,
    },
    CREATED_COLUMN(),
    UPDATED_COLUMN(),
    AUTHOR_COLUMN(),
  ],
};
